import { cx } from "@emotion/css";
import { ArrowUpDown } from "lucide-react";
import { Menu } from "src/components/Default/LekUI/Menu";

export interface SortOption<TSortBy extends string, TSortOrder extends string> {
	sortBy: TSortBy;
	sortOrder: TSortOrder;
	label: string;
	testId?: string;
}

interface SortProps<TSortBy extends string, TSortOrder extends string> {
	options: SortOption<TSortBy, TSortOrder>[];
	sortBy: TSortBy;
	sortOrder: TSortOrder;
	onChange: (sortBy: TSortBy, sortOrder: TSortOrder) => void;
	defaultSortBy?: TSortBy;
	defaultSortOrder?: TSortOrder;
	anchorId?: string;
	buttonTestId?: string;
}

export function Sort<TSortBy extends string, TSortOrder extends string>({
	options,
	sortBy,
	sortOrder,
	onChange,
	defaultSortBy,
	defaultSortOrder,
	anchorId,
	buttonTestId,
}: SortProps<TSortBy, TSortOrder>) {
	const isActive =
		(defaultSortBy != null && sortBy !== defaultSortBy) ||
		(defaultSortOrder != null && sortOrder !== defaultSortOrder);

	return (
		<Menu
			anchorId={anchorId}
			buttonTestId={buttonTestId}
			closeAfterClick
			icon={
				<ArrowUpDown
					className={cx("icon-small", { "icon-primary": isActive })}
				/>
			}
			items={options.map((opt) => ({
				title: opt.label,
				onClick: () => onChange(opt.sortBy, opt.sortOrder),
				selected: opt.sortBy === sortBy && opt.sortOrder === sortOrder,
				testId: opt.testId,
			}))}
		/>
	);
}
